import { State } from '../StateTypes';

export const selectDraftData = (state: State) => state.draft;

export const selectDraftDataSlice = (key: string) => (state: State) =>
  // @ts-ignore LIMITATION OF ANCIENT, PRE-HISTORIC TS-VERSION NOT SUPPORTING ENUMS
  state.draft.present[key];
